module.exports = __webpack_public_path__ + "img/fb-share.ca1bfd0a.jpg";